import { makeStyles, Grid, Typography, Box, TextField } from "@material-ui/core";

import { DialogBox } from "../boxes";
import { Dialog, Icon, TextButton, Button, DropdownInput } from "../base";
import CloseIcon from "../../assets/images/modals/CloseModal.svg";
import LocationIcon from "../../assets/images/icons/workspace/location.svg";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  location: {
    display: "flex",
    alignItems: "flex-start",
    margin: "32px 0 28px 0",
    minWidth: 516,
  },
  rebate: {
    display: "flex",
    alignItems: "center",
    margin: "0 0 70px 32px",
  },
  addPolicy: {
    padding: "10px 30px",
    borderRadius: "21px",
  },
  heading: {
    fontWeight: 700,
    color: COLORS.darks[0][100],
    fontSize: 24,
  },
  iconWrapper: {
    height: "25px",
  },
}));

export const TenantsRebatePolicyModal = ({ isOpen, setOpen, building }) => {
  const classes = useStyles();

  return (
    <Dialog isOpen={isOpen} onClose={() => setOpen(false)}>
      <DialogBox sty>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography className={classes.heading}>Tenants Rebate policy</Typography>
          <Icon
            root={classes.iconWrapper}
            src={CloseIcon}
            hoverable
            tooltip="Close"
            onClick={() => setOpen(false)}
          />
        </Grid>
        <Typography style={{ fontStyle: "italic", color: COLORS.darks[0][50] }}>
          Note- Policy applied to all units in this building
        </Typography>
        <Box className={classes.location}>
          <Icon src={LocationIcon} />
          <Box style={{ marginLeft: "10px" }}>
            <Typography style={{ fontSize: 16 }}>{building?.address || "No address"}</Typography>
            <Typography style={{ fontSize: 16, color: COLORS.darks[0][50] }}>120 Units</Typography>
          </Box>
        </Box>
        <Box className={classes.rebate}>
          <Typography style={{ fontSize: "16px", fontWeight: "500" }}>Rebate policy:</Typography>
          <Box style={{ margin: "0 4px 0 9px" }}>
            <TextField
              defaultValue={10}
              variant="outlined"
              style={{ minWidth: "50px", width: "50px" }}
              inputProps={{
                style: {
                  height: "4px",
                  padding: "14px",
                },
              }}
            />
          </Box>
          <DropdownInput
            options={["%"]}
            fullWidth={false}
            defaultValue="%"
            iconWidth={10}
            inputPadding="6px 0 5px 10px"
          />
        </Box>
        <Grid container alignItems="center">
          <Button
            rootStyle={classes.addPolicy}
            text="ADD POLICY"
            onClick={() => console.log("apply")}
          />
          <TextButton
            text="DISCARD CHANGES"
            style={{ marginLeft: "30px" }}
            onClick={() => setOpen(false)}
          />
        </Grid>
      </DialogBox>
    </Dialog>
  );
};
